import { STEP_TO_WATERFALL_INDEX_MAP } from './placesAnalyticsAppLoadE2E';
import { PlacesAnalyticsCoreEventBase } from './placesAnalyticsCoreEventBase';
import { PlacesMarkerTimeout } from './constants';
import { PerformanceCoreDatapoint } from 'owa-analytics';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * Measures from the beginning of Admin Role Switch (from Employee) and ends on completion of home page load.
 */
class PlacesAnalyticsAdminRoleSwitchE2E extends PlacesAnalyticsCoreEventBase<
    typeof STEP_TO_WATERFALL_INDEX_MAP
> {
    protected createNewPerformanceCoreDatapoint(): PerformanceCoreDatapoint {
        return new PerformanceCoreDatapoint(
            'PlacesAnalyticsAdminRoleSwitchE2E',
            getModuleContextMailboxInfo(),
            {
                timeout: PlacesMarkerTimeout,
            }
        );
    }

    protected getStepToWaterfallIndexMap(): typeof STEP_TO_WATERFALL_INDEX_MAP {
        return STEP_TO_WATERFALL_INDEX_MAP;
    }
}

export const placesAnalyticsAdminRoleSwitchE2E: PlacesAnalyticsAdminRoleSwitchE2E =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
     *	> Function PlacesAnalyticsAdminRoleSwitchE2E called at module scope is not allowed. This may cause unwanted side effects. */
    new PlacesAnalyticsAdminRoleSwitchE2E();
